module.exports = __webpack_public_path__ + "static/img/icon_Scan1.a13daf28.png";